/**
 * Playwright-only dev bypass: pretend the SPA is authenticated and attach a
 * static Bearer token for axios (see AuthAxiosProvider).
 *
 * Guardrails:
 * - Only when `import.meta.env.DEV` is true (stripped from production builds).
 * - Requires `VITE_E2E_BYPASS_AUTH=true` baked by Vite at dev-server start.
 * - Requires `globalThis.__QC_LITE_E2E__` set via Playwright `addInitScript`
 *   before the app bundle runs (never set in normal browser use).
 */
export function isQcLiteE2eBypass() {
  return (
    import.meta.env.DEV === true &&
    import.meta.env.VITE_E2E_BYPASS_AUTH === 'true' &&
    typeof globalThis !== 'undefined' &&
    globalThis.__QC_LITE_E2E__ === true
  );
}
